import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type RecentOrder = {
  id: number;
  amazonOrderId: string;
  itemName?: string;
  visitedAt: string;
};

const MAX_RECENT_ORDERS = 10;

type State = {
  orders: RecentOrder[];
};

type Action = {
  pushOrder: (_order: Omit<RecentOrder, "visitedAt">) => void;
  clear: () => void;
};

/** Ctrl+K paletindeki "Son Görüntülenen Siparişler" bölümünü besler */
export const useRecentOrdersStore = create<State & Action>()(
  persist(
    (set) => ({
      orders: [],

      pushOrder: (order) =>
        set((s) => ({
          orders: [
            { ...order, visitedAt: new Date().toISOString() },
            ...s.orders.filter((o) => o.id !== order.id),
          ].slice(0, MAX_RECENT_ORDERS),
        })),

      clear: () => set({ orders: [] }),
    }),
    {
      name: "syncrosale-recent-orders",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
